/* eslint-disable react/require-default-props */
import { FlexGroup, FlexItem, Spacer, Text } from '@antoree/ant-ui';
import { FormattedMessage } from 'react-intl';
import Td from './Td';

export type HeaderTestResultProps = {};
const AdultScore: React.FC<HeaderTestResultProps> = ({}) => {
  return (
    <FlexGroup>
      <FlexItem>
        <Text color="subdued">
          <span>Score for each criteria/ Điểm cho từng tiêu chí</span>
        </Text>
        <table className="table-fixed">
          <tbody>
            <tr>
              <Td>0</Td>
              <Td>1</Td>
              <Td>2</Td>
              <Td>3</Td>
              <Td>4</Td>
              <Td>5</Td>
              <Td>6</Td>
              <Td>7</Td>
              <Td>8</Td>
              <Td>9</Td>
            </tr>
            <tr>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Not Applicable" />
                </strong>
              </Td>
              <Td colSpan={2}>
                <strong>
                  <FormattedMessage defaultMessage="Applicable with many mistakes" />
                </strong>
              </Td>
              <Td colSpan={2}>
                <strong>
                  <FormattedMessage defaultMessage="Basic" />
                </strong>
              </Td>
              <Td colSpan={2}>
                <strong>
                  <FormattedMessage defaultMessage="Adaptable" />
                </strong>
              </Td>
              <Td colSpan={2}>
                <strong>
                  <FormattedMessage defaultMessage="Good with few mistakes" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="Perfect" />
                </strong>
              </Td>
            </tr>
          </tbody>
        </table>
        <Spacer size="m" />
        <Text color="subdued">
          <span>Total score and level/ Tổng điểm và trình độ</span>
        </Text>
        <table className="table-fixed">
          <tbody>
            <tr>
              <Td>0.0 – 0.5</Td>
              <Td>1.0 – 2.5</Td>
              <Td>3.0 – 3.5</Td>
              <Td>4.0 – 5.0</Td>
              <Td>5.5 – 6.5</Td>
              <Td>7.0 – 8.0</Td>
              <Td>8.5 – 9.0</Td>
            </tr>
            <tr>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="A0 (Starter)" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="A1 (Beginner)" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="A2 (Elementary)" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="B1 (Intermediate)" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="B2 (Upper - Intermediate)" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="C1 (Advanced)" />
                </strong>
              </Td>
              <Td>
                <strong>
                  <FormattedMessage defaultMessage="C2 (Proficiency)" />
                </strong>
              </Td>
            </tr>
          </tbody>
        </table>
      </FlexItem>
    </FlexGroup>
  );
};

export default AdultScore;
